export default __webpack_public_path__ + "static/media/backer-mb.e1911204.webp";